module.exports = __webpack_public_path__ + "img/ikon-sv_l.c304fd12.png";